<template>
    <Button id="captcha-button" size="small" type="primary" @click="getCaptcha">{{buttonWord}}</Button>
</template>

<script>
import { Button, Toast } from 'vant'
import { userApi } from '@/apis'
const STATUS = {
    READY: 0,
    WAITING: 1,
}
const WAITING_TIME = 60
let timer = null

export default {
    name: 'CaptchaButton',
    props: ['phone', 'source'],
    components: {
        Button
    },
    data () {
        return {
            time: 0,
            status: STATUS.READY
        }
    },
    computed: {
        disabled () {
            return this.time < 0
        },
        buttonWord () {
            switch (this.status) {
                case 0:
                    return '获取验证码'
                case 1:
                    return `${this.time}s后重试`
                default:
                    return '获取验证码'
            }
        },
        timeStorageKey () {
            return `${this.source}_captchaTimeStamp`
        }
    },
    methods: {
        getLeftTime () {
            // 上次访问未发送验证码
            const captchaTimeStamp = localStorage.getItem(this.timeStorageKey)
            if (!captchaTimeStamp) return

            // 上次访问发送过验证码
            const move = Math.floor((Date.now() - captchaTimeStamp) / 1000)
            if (move > WAITING_TIME) return localStorage.removeItem(this.timeStorageKey)
            this.time = WAITING_TIME - move

            this.status = STATUS.WAITING
            this.timeCalculate()
        },
        async getCaptcha () {
            if (this.status === STATUS.WAITING) return Toast('请等待')
            // check tel
            if (!/^1[3456789]\d{9}$/.test(this.phone)) return Toast('手机号有误')
            // await api
            try {
                await userApi.verificationsPost({
                    body: {
                        phone: this.phone,
                        approach: this.source === 'sun' ? 'chaoyang' : 'nongyebu'
                    }
                })
                this.time = WAITING_TIME
                this.status = STATUS.WAITING
                localStorage.setItem(this.timeStorageKey, Date.now())
                this.timeCalculate()

                Toast('验证码发送成功')
            } catch (err) {
                console.log('verifications err', err)
            }
        },
        timeCalculate () {
            // 清除之前的定时器
            timer && clearInterval(timer)
            // 减时间
            timer = setInterval(() => {
                this.time -= 1
                if (this.time <= 0) {
                    clearInterval(timer)
                    localStorage.removeItem(this.timeStorageKey)
                    this.status = STATUS.READY
                }
            }, 1000)
        }
    },
    mounted () {
        this.getLeftTime()
    }
}
</script>